import { LoadingButton } from '../../../../../Button/src/tsx/Button';
import { useBookingContext } from '../../contexts/BookingContext';

interface SubmitAppointmentButtonProps {
	getLabel: (key: string) => string;
}

export default function SubmitAppointmentButton({ getLabel }: SubmitAppointmentButtonProps) {
	const { appointment, form } = useBookingContext();

	return (
		<LoadingButton
			disabled={!appointment.timeSlot || appointment.timeSlotExpired}
			loading={appointment.isSubmitting}
			onClick={form.submit}
			primary={true}
			testId="submit-appointment"
		>
			{getLabel('booking_submit_button')}
		</LoadingButton>
	);
}
